import styled from 'styled-components';
export const Container = styled.li `
  margin-bottom: 16px;
  margin-left: 24px;
  padding-left: 8px;
`;
export const Title = styled.div `
  font-size: 16px;
  line-height: 24px;
`;
export const Content = styled.div `
  font-weight: 400;
  margin-top: 8px;
`;
